// The account menu's shortcut to this device's notification controls.
import { m } from "@trameria/i18n";
import type { ReactNode } from "react";
import { QuickRow } from "../shell/account-quick";
import { Switch } from "../ui/bits";

export function NotificationQuickSetting({
  checked,
  disabled,
  onChange,
  note,
}: {
  checked: boolean;
  disabled?: boolean;
  onChange(on: boolean): void;
  note?: ReactNode;
}) {
  const label = m.notices_settings_title();
  return (
    <>
      <QuickRow icon="bell" label={label}>
        <Switch
          label={label}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
      </QuickRow>
      {note && <div className="px-3 pb-1 text-[12px] text-muted">{note}</div>}
    </>
  );
}
